import { useAuth0 } from '@auth0/auth0-react'

import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { Footer } from '../components/Footer'
import { MyReviews as MyReviewsComponent } from '../components/MyReviews'
import { Spinner } from '../components/Spinner'
import { TopLogo } from '../components/TopLogo'

const MyReviews = (): JSX.Element => {
  const { isAuthenticated, isLoading } = useAuth0()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      history.replace(`/login/redirect/${encodeURIComponent(location.pathname)}`)
    }
  }, [isAuthenticated, isLoading, history, location])

  // Don't render until auth is ready
  if (isLoading || !isAuthenticated) {
    return (
      <div id="page-root" className="h-screen overflow-auto relative">
        <TopLogo />
        <div className="flex justify-center items-center py-20 min-h-[400px]">
          <Spinner size="lg" />
        </div>
      </div>
    )
  }

  return (
    <div id="page-root" className="h-screen overflow-auto relative">
      <TopLogo />

      <div className="px-4 max-w-4xl mx-auto py-8">
        <div className="mb-6">
          <h1 className="text-3xl md:text-4xl font-bold text-graphite-grey mb-2">My Reviews</h1>
          <p className="text-gray-600">View and manage all your submitted reviews</p>
        </div>
        <MyReviewsComponent />
      </div>

      <div className="mt-12">
        <Footer />
      </div>
    </div>
  )
}

export default MyReviews
